
<template>
    <template v-if="item?.data" :key="item.data.id">
        <div class="Heading flex" v-if="routeData.action !== 'related'">
            <div class="left">
                <button type="button" class="button inline" @click.prevent="handleBack" v-if="routeData.action !== 'related'">
                    <Icon name="back" />
                </button>
            </div>
            <div class="center">
            </div>
            <div class="right"></div>
        </div>
        <div class="Heading flex noborder" :class="{useHand:routeData.action === 'related'}" @click="handleHeadingClick">
            <div class="left">
                <h1 class="h3 title">
                    <span class="subject">
                        <Icon v-if="attachmentCount(item)" name="paperclip" :title="trans('Bevat %s bijlagen',  attachmentCount(item))" />
                        <span class="title">{{ item.data.subject }}</span>
                    </span>
                </h1>
                <span class="tags">
                    <InboxTags :item="item" />
                </span>
            </div>
            <div class="right">

            </div>
        </div>
        <div class="Heading flex noborder" :set="dateObject = new Date(date(item))">
            <div class="left" :class="{useHand:routeData.action === 'related'}" @click="handleHeadingClick">
                <div class="author">
                    <div class="left">
                        <figure class="avatar">
                            <img :src="avatar(item)" :alt="contact_name(item)" />
                        </figure>
                    </div>
                    <div class="right">
                        <div class="sender_name">
                            <span class="name" v-if="contact_name(item)">
                                {{ contact_name(item) }}
                            </span>
                            <span class="ago" v-if="date(item)">
                                <timeago :datetime="dateObject" />
                            </span>
                        </div>
                        <div class="sender_uid">{{ contact_uid(item) }}</div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="receive_date">
                    {{ formatDate(dateObject) }}
                </div>
                <!--<InboxActions :routeData="routeData" v-if="!isSent(item)" />-->
            </div>
        </div>
        <div class="Heading flex noborder" v-if="attachmentCount(item)">
            <div class="center">
                <InboxAttachments :item="item" />
            </div>
        </div>
        <iframe class="Content" border="0" width="100%" :srcdoc="html(item)" ref="iframe" @load="adjustIframeHeight"/>
    </template>
    <template v-else>
        <span v-html="trans('Bezig met laden van bericht...')"></span>
    </template>
</template>

<script>
import {defineComponent, onMounted, computed, inject, ref, watch, onUnmounted} from "vue";
import { useRouter } from "vue-router";

// Config for API urls used in this vue template
import { inboxStore, getInbox, patchInbox, clearInboxCache } from "store/inbox-store";

import {
    routeData,
    handleFavoriteToggle,
    handleImportantToggle,
    isSent,
    source,
    read,
    favorite,
    important,
    date,
    contact_name,
    contact_uid,
    avatar,
    attachments,
    attachmentCount,
    html,
    iframe,
    adjustIframeHeight,

    formatDate,
    twoWeeks,
    selected,
    selectedAll,
    handleSelect,
    handleSelectAll,

    handleMounted,
    handleUnmounted
} from "helpers/_inbox-helpers";

import Icon from "components/icon";

import InboxActions from "view/inbox/includes/inbox-actions";
import InboxTags from "view/inbox/includes/inbox-tags";
import InboxAttachments from "view/inbox/includes/inbox-attachments";

import trans from "helpers/_translation";

export default defineComponent({
    name: "inbox-detail",
    components: {
        Icon,
        InboxActions,
        InboxTags,
        InboxAttachments
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const router = useRouter();

        const item = computed(() => {
            return props.item;
        });

        const handleBack = () => {
            router.push({
                path: `/inbox/${routeData.action}`,
                query: {
                    page: routeData.page
                }
            });
        };
        const handleHeadingClick = (e) => {
            if (routeData.action !== 'related') {
                return;
            }
            e.preventDefault();
            routeData.item_id = null;
            routeData.current = null;
        };

        return {
            trans,

            item,
            routeData,

            formatDate,
            twoWeeks,

            avatar,
            attachments,
            attachmentCount,

            isSent,
            read,
            favorite,
            important,
            date,
            contact_name,
            contact_uid,

            html,
            iframe,
            adjustIframeHeight,

            handleBack,
            handleHeadingClick
        }
    }
});

</script>
